(function () {
    angular.module('tmx-app').factory('GeoTrackingService', ['tmxResource', function (tmxResource) {

        var gt = tmxResource("geotracking");

        gt.columns = [
            {
                field: "EventName",
                title: "Event",
                type: "text",
                width: "20",
                scrollable: false,
                resizable: true,
                headerTemplate: "<span ng-class=\"{}\"> {{'Event'|translate}} </span>"
            },
            {
                field: "LoanApplicationNumber",
                title: "Loan App No",
                type: "text",
                width: "20",
                scrollable: false,
                resizable: true,
                headerTemplate: "<span ng-class=\"{}\"> {{'Loan App No'|translate}} </span>"
            },
            {
                field: "CustomerName",
                title: "Loan Applicant",
                type: "text",
                width: "20",
                scrollable: false,
                resizable: true,
                headerTemplate: "<span ng-class=\"{}\"> {{'Loan Applicant'|translate}} </span>"
            },
            {
                field: "Status",
                title: "App Status",
                type: "text",
                width: "20",
                scrollable: false,
                resizable: true,
                headerTemplate: "<span ng-class=\"{}\"> {{'App Status'|translate}} </span>"
            },
            {
                field: "CreatedDate",
                title: "Created Date",
                type: "text",
                width: "20",
                scrollable: false,
                resizable: true,
                headerTemplate: "<span ng-class=\"{}\"> {{'Created Date'|translate}} </span>"
            },
            {
                field: "EventStartTime",
                title: "Time In",
                type: "text",
                width: "20",
                scrollable: false,
                resizable: true,
                headerTemplate: "<span ng-class=\"{}\"> {{'Start Time '|translate}} </span>"
            },
            {
                field: "EventEndTime",
                title: "Time Out",
                type: "text",
                width: "30",
                scrollable: false,
                resizable: true,
                headerTemplate: "<span ng-class=\"{}\"> {{'  End Time'|translate}} </span>"
            },
            {
                field: "TrasitTime",
                title: "Transit Time",
                type: "text",
                width: "5",
                scrollable: false,
                resizable: true,
                headerTemplate: "<span ng-class=\"{}\"> {{'Tran. Time(min)'|translate}} </span>"
            },
            {
                field: "Latitude",
                title: "Latitude",
                type: "text",
                width: "20",
                scrollable: false,
                resizable: true,
                headerTemplate: "<span ng-class=\"{}\"> {{'Latitude'|translate}} </span>"
            },
            {
                field: "Longitude",
                title: "Longitude",
                type: "text",
                width: "20",
                scrollable: false,
                resizable: true,
                headerTemplate: "<span ng-class=\"{}\"> {{'Longitude'|translate}} </span>"
            }
        ];

        return gt;

    }]);
})();
